import { ActionResult } from '../enums';
import type { ActionHandler } from '../types';
import { notifyStorageUpdated } from './sessionStorageSet';

type NamespacedContent = Record<string, Record<string, unknown>>;
type LocalStorageSet = { content?: NamespacedContent };

/**
 * localStorageSetHandler
 * Stores all values from options.content into localStorage using a namespaced key format:
 * "namespace:key" -> JSON.stringify(value)
 * required for @{ctx/namespace:key} -> retrieving value stored in localStorage
 */
export const localStorageSetHandler: ActionHandler<LocalStorageSet> = (
  action
) => {
  const { content } = (action.options ?? {}) as LocalStorageSet;
  if (!content || typeof content !== 'object') return ActionResult.Error;

  for (const [namespace, entries] of Object.entries(content)) {
    if (!entries || typeof entries !== 'object') continue;
    for (const [key, value] of Object.entries(entries)) {
      localStorage.setItem(`${namespace}:${key}`, JSON.stringify(value));
    }
  }

  notifyStorageUpdated();

  return ActionResult.Success;
};
